import { DI } from '@microsoft/fast-foundation';
/**
 * The default implementation for the Session interface.
 * @public
 */
export class DefaultSession {
    constructor() {
        /**
         * The prefix to use for all storage keys.
         * @internal
         */
        this.storageKeyPrefix = '';
        this.returnUrl = this.getSessionStorageItem('returnUrl') || '';
    }
    deleteUserFromSessionStorage() {
        const storageKeys = ['authToken', 'refreshToken', 'sessionId', 'ssoToken'];
        storageKeys.forEach((key) => this.removeSessionStorageItem(key));
    }
    setStorageKeyPrefix(prefix) {
        this.storageKeyPrefix = `${prefix.replace(/\s/g, '')}/`;
    }
    setAuthResult(result) {
        this.setSessionStorageItem('authToken', result.SESSION_AUTH_TOKEN);
        this.setSessionStorageItem('refreshToken', result.REFRESH_AUTH_TOKEN);
        this.setSessionStorageItem('username', result.USER_NAME);
        this.setSessionStorageItem('sessionId', result.SESSION_ID);
    }
    captureReturnUrl() {
        const { pathname, search, hash } = location;
        /**
         * This block shouldn't be required and might mean there's a code issue elsewhere. Login is obvious a public route,
         * so there would be no need to call captureReturnUrl from a nav contributor when trying to visit it.
         */
        if (pathname === '/login') {
            return;
        }
        const path = `${pathname !== '/' ? pathname : ''}`;
        this.returnUrl = `${path}${search}${hash}`;
        this.setSessionStorageItem('returnUrl', this.returnUrl);
    }
    setItem(key, value, storage) {
        if (storage === 'local') {
            localStorage.setItem(this.storageKeyPrefix + key, value);
        }
        else {
            sessionStorage.setItem(this.storageKeyPrefix + key, value);
        }
    }
    getItem(key, storage) {
        if (storage === 'local')
            return localStorage.getItem(this.storageKeyPrefix + key);
        return sessionStorage.getItem(this.storageKeyPrefix + key);
    }
    removeItem(key, storage) {
        if (storage === 'local') {
            localStorage.removeItem(this.storageKeyPrefix + key);
        }
        else {
            sessionStorage.removeItem(this.storageKeyPrefix + key);
        }
    }
    setLocalStorageItem(key, value) {
        this.setItem(key, value, 'local');
    }
    setSessionStorageItem(key, value) {
        this.setItem(key, value, 'session');
    }
    getLocalStorageItem(key) {
        return this.getItem(key, 'local');
    }
    getSessionStorageItem(key) {
        return this.getItem(key, 'session');
    }
    removeLocalStorageItem(key) {
        this.removeItem(key, 'local');
    }
    removeSessionStorageItem(key) {
        this.removeItem(key, 'session');
    }
}
/**
 * The DI token for the Session interface.
 * @internal
 */
export const Session = DI.createInterface((x) => x.singleton(DefaultSession));
